<template>
  <div
    class="text-sm font-medium text-center text-black-800 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700"
  >
    <ul class="flex flex-wrap -mb-px">
      <li class="mr-2">
        <span
          @click="toggleTab('shortview')"
          class="inline-block p-4 border-b-2 cursor-pointer"
          :class="
            props.tab == 'shortview'
              ? 'border-yellow-600 text-green-800 rounded-t-lg active dark:text-green-800 dark:border-green-800 font-bold'
              : 'border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300'
          "
          >มุมมองสั้น</span
        >
      </li>
      <li class="mr-2">
        <span
          @click="toggleTab('longview')"
          class="inline-block p-4 border-b-2 cursor-pointer"
          :class="
            props.tab == 'longview'
              ? 'border-yellow-600 text-green-800 rounded-t-lg active dark:text-green-800 dark:border-green-800 font-bold'
              : 'border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300'
          "
          aria-current="page"
          >มุมมองยาว</span
        >
      </li>
    </ul>
  </div>
</template>

<script setup>
import { set } from "@vueuse/core";
const ResultViewTypeYeekee5 = useResultViewTypeYeekee5();
const ResultViewTypeYeekee10 = useResultViewTypeYeekee10();
const ResultViewTypeYeekee15 = useResultViewTypeYeekee15();
const props = defineProps({
  slug: String,
  tab: String,
});

function toggleTab(data) {
  if (props.slug === "yeekee_5") {
    set(ResultViewTypeYeekee5, data);
  }
  if (props.slug === "yeekee_10") {
    set(ResultViewTypeYeekee10, data);
  }
  if (props.slug === "yeekee_15") {
    set(ResultViewTypeYeekee15, data);
  }
}
</script>
<style scope></style>
